import React, { FC } from 'react';
import { Platform } from 'react-native';
import { withIAPContext } from 'react-native-iap';

import View from './View';
import { useViewModel } from './viewModel';
import Screen from '../navigation/components/ApplicationScreen';
import type { MainProps } from './types';

const Main: FC<MainProps> = (props) => {
    const viewModelProps = useViewModel(props);
    return <View {...viewModelProps} />;
};
Main.displayName = 'ApplicationMain';

const Application = {
    Main: ['ios', 'android'].includes(Platform.OS) && withIAPContext ? withIAPContext(Main) : Main,
    View,
    useViewModel,
    Screen,
};

export default Application;
